// bmi
<template>

  <div>
    <div class="item-hd">
      <div>
        {{ $t('viewBase.a90') }}：
        <div class="tag" @click="showStartDate=true">
          {{ first ? dateFormat(start, 'YYYY/MM/DD') : $t('viewBase.a50') }}
        </div>
        -
        <div class="tag" @click="showEndDate=true">
          {{ first ? dateFormat(end, 'YYYY/MM/DD') : $t('viewBase.a51') }}
        </div>
      </div>
      <van-icon name="plus" class="addData" @click="handlePopup" />
    </div>

    <van-list
      v-model="loading"
      :finished="finished"
      :finished-text="tips"
      @load="getList"
    >
      <div v-for="(item,index) in list" :key="index" class="data">
        <div class="hd">
          {{ dateFormat(item.testTime, 'M-D hh:mm') }}
        </div>
        <div class="bd">
          <div>
            <span v-if="item.state==='string'||item.state===''||item.state==='0'||item.state===null">
              {{ item.sbp }}/{{ item.dbp }}
            </span>
            <span v-else-if="!item.normal">
              <span v-if="strChangeArr(item.state2)[0]!=='正常'" class="abnormal">
                {{ item.sbp }}
              </span>
              <span v-else>
                {{ item.sbp }}
              </span>
              <span>/</span>
              <span v-if="strChangeArr(item.state2)[1]!=='正常'" class="abnormal">
                {{ item.dbp }}
              </span>
              <span v-else>
                {{ item.dbp }}
              </span>
            </span>
            <span v-else>{{ item.sbp }}/{{ item.dbp }}</span>&nbsp;mmHg
            <i v-if="strChangeArr(item.state2)[0]==='偏高'||strChangeArr(item.state2)[1]==='偏高'" class="iconfont icon-iconset0414 abnormal" />
            <i v-if="strChangeArr(item.state2)[0]==='偏低'||strChangeArr(item.state2)[1]==='偏低'" class="iconfont icon-xiajiantou abnormal" />
            <span v-if="strChangeArr(item.state2)[0]==='正常'&&strChangeArr(item.state2)[1]==='正常'" class="abnormal-mr" />
          </div>
          <!-- <div class="meta">
            脉差{{ item.sbp - item.dbp }}
          </div> -->
        </div>
      </div>
    </van-list>
    <!-- start -->
    <van-datetime-picker
      v-show="showStartDate"
      v-model="start"
      type="date"
      :max-date="end"
      cancel-button-text=" "
      @confirm="handleDateConfirm('start')"
    />
    <!-- end -->
    <van-datetime-picker
      v-show="showEndDate"
      v-model="end"
      type="date"
      :max-date="maxDate"
      cancel-button-text=" "
      @confirm="handleDateConfirm('end')"
    />

    <van-popup v-model="showPopup" position="bottom" @close="showMeasureDate=false">
      <div class="popup-title">{{ $t('viewBase.a92') }}</div>
      <van-cell-group>
        <van-field
          v-model="dataForm.height"
          clearable
          label="身高"
          input-align="right"
          placeholder="请输入身高"
        />
        <van-field
          v-model="dataForm.width"
          clearable
          label="体重"
          input-align="right"
          placeholder="请输入体重"
        />
        <van-cell title="测量时间" :value="dataForm.measureDate ? dateFormat(dataForm.measureDate, 'YYYY-MM-DD hh:mm') : $t('viewBase.a72')" is-link @click="showMeasureDate=true" />
        <van-button type="info" class="btn" @click="submit">提交</van-button>
      </van-cell-group>
    </van-popup>

    <van-datetime-picker
      v-show="showMeasureDate"
      v-model="dataForm.measureDate"
      type="datetime"
      cancel-button-text=" "
      :max-date="maxDate"
      @confirm="handleMeasureDateConfirm"
    />

  </div>
</template>

<script>
import { getAccountId } from '@/utils/auth'
import { dateFormat, dateISO, strChangeArr } from '@/utils/tool'
import { fetchBMI, postBMI } from '@/api/health'

export default {
  data() {
    const date = new Date()
    date.setMonth(date.getMonth() - 1)
    return {
      first: false,
      showMeasureDate: false,
      datetime: new Date(),
      showPopup: false,
      dateFormat,
      strChangeArr,
      showStartDate: false,
      showEndDate: false,
      start: date,
      end: new Date(),
      maxDate: new Date(),
      currentDate: new Date(),
      tips: '',
      loading: false,
      finished: false,
      list: [],
      listQuery: {
        sTime: dateISO(`${dateFormat(date, 'YYYY/MM/DD')} 00:00:01`),
        eTime: dateISO(`${dateFormat(new Date(), 'YYYY/MM/DD')} 23:59:59`),
        page: 1,
        row: 20
      },
      dataForm: {
        accountId: getAccountId() || 1,
        deviceCode: 'string',
        state: 'string',
        measureDate: new Date()
      }
    }
  },
  created() {

  },
  methods: {
    getList(date) {
      if (this.start) {
        this.listQuery.sTime = dateISO(`${dateFormat(this.start, 'YYYY/MM/DD')} 00:00:01`)
      }
      if (this.end) {
        this.listQuery.eTime = dateISO(`${dateFormat(this.end, 'YYYY/MM/DD')} 23:59:59`)
      }
      fetchBMI(this.listQuery).then(res => {
        this.loading = false
        const list = res.data.data
        if (this.listQuery.page === 1) {
          this.list = list
        } else {
          this.list = this.list.concat(list)
        }
        this.listQuery.page++
        this.finished = list.length < 20
        this.tips = this.list.length ? this.$t('viewBase.a46') : this.$t('viewBase.a47')
      })
    },

    handleDateConfirm(e) {
      this.first = true
      this.showStartDate = false
      this.showEndDate = false
      this.listQuery.page = 1
      this.getList()
    },
    handleMeasureDateConfirm() {
      this.showMeasureDate = false
      this.datetime = this.currentDate
    },

    handlePopup() {
      this.showPopup = true
    },
    submit() {
      this.dataForm.testTime = dateISO(this.dataForm.measureDate)
      postBMI([this.dataForm]).then(res => {
        this.$toast('提交成功')
        this.showPopup = false
        this.showMeasureDate = false
        this.listQuery.page = 1
        this.currentDate = new Date()
        this.getList()
      })
    }
  }
}
</script>

<style scoped lang="scss">
  .item-hd {
    background: #fff;
    padding: 10px 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: sticky;
    top: 46px;
  }
  .addData {
      font-size: 18px;
  }
  .tag {
    display: inline-block;
    color: #666;
    padding: 8px 12px;
    background: #f6f6f6;
    border-radius: 1px solid #ececec;
    border-radius: 15px;
  }
  .data {
      display: flex;
      justify-content: space-between;
      background: #fff;
      margin-top: 10px;
      padding: 12px 15px;
      .hd {
          color: #666;
      }
      .bd {
          text-align: right;
      }
  }
  .van-picker {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9999;
    }
    .popup-title {
        text-align: center;
        padding: 10px;
        font-weight: bold;
    }
    .btn {
        width: 92%;
        margin: 30px 4% 20px;
    }
    .meta {
      font-size: 12px;
    }
    .bd span{
      width:auto;
      display: inline-block;
    }
    .bd .abnormal-mr{
width:16px;
    }
</style>
